<template>
  <v-text-field v-bind="$attrs" v-on="$listeners" :inheritAttrs="false" />
</template>

<script>
  export default {
    name: 'wh-textfield'
  }
</script>